import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/Commission/create.js";
import PropTypes from "prop-types";
import { useParams, Redirect } from "react-router-dom";
import { bookingApi } from "functions/apis";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import CardHeader from "components/Card/CardHeader";
import Card from "components/Card/Card";
import CardIcon from "components/Card/CardIcon";
import { Check, MailOutline } from "@material-ui/icons";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel
} from "@material-ui/core";
import Datetime from "react-datetime";
import { tripDateFormat } from "functions/Helper";

const useStyles = makeStyles(styles);

export default function DeleteAgentBookingPromoCodes(props) {
  const [redirect, setRedirect] = useState(false);
  const [body, setBody] = useState({
    agentID: null,
    promoCode: null,
    effectiveFrom: null,
    effectiveUntil: null,
    discountAmount: null,
    minimalPax: null,
    onlyForRoundTrip: false,
    hasSectorRestriction: false,
    limit: 0,
    allowedSectorID: [],
    allowedSector: null,
    agent: null
  });

  const { id } = useParams();

  const deleteAgentBookingPromoCodesSignal = React.useRef(
    new AbortController()
  );

  const getData = () => {
    bookingApi
      .get("AgentBookingPromoCodes/" + id, {
        signal: deleteAgentBookingPromoCodesSignal.current.signal,
        params: {
          ID: id
        }
      })
      .then(data => {
        setBody({
          agentID: data.agent.id,
          allowedSectorID: data.allowedSector ? data.allowedSector.id : null,
          discountAmount: data.discountAmount,
          effectiveFrom: new Date(data.effectiveFrom + "Z"),
          effectiveUntil: new Date(data.effectiveUntil + "Z"),
          hasSectorRestriction: data.hasSectorRestriction,
          limit: data.limit,
          minimalPax: data.minimalPax,
          onlyForRoundTrip: data.onlyForRoundTrip,
          promoCode: data.promoCode,
          allowedSector: data.allowedSector,
          agent: data.agent
        });
      })
      .catch(error => console.log(error));
  };

  useEffect(() => {
    getData();

    return () => deleteAgentBookingPromoCodesSignal.current.abort();
  }, []);

  const onPressDelete = () => {
    bookingApi
      .delete("AgentBookingPromoCodes/" + id, {
        signal: deleteAgentBookingPromoCodesSignal.current.signal,
        params: {
          ID: id
        }
      })
      .then(() => {
        setRedirect(true);
      })
      .catch(error => console.log(error));
  };

  const classes = useStyles();

  return redirect ? (
    <Redirect to={"/admin/AgentBookingPromoCodeList"} />
  ) : (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              DELETE AGENT BOOKING PROMO CODES
            </h4>
          </CardHeader>
          <CardBody>
            <p>Delete this Promo Code?</p>
            <Button onClick={() => props.history.goBack()} value="Back">
              CANCEL
            </Button>
            <Button
              onClick={() => onPressDelete()}
              color="rose"
              type="submit"
              value="Submit"
            >
              DELETE
            </Button>
            <GridContainer>
              <GridItem xs={12} md={6}>
                <CustomInput
                  labelText="Agent"
                  formControlProps={{
                    fullWidth: true
                  }}
                  disabled
                  inputProps={{
                    value: body.agent ? body.agent.name : "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={6}>
                <CustomInput
                  labelText="Promo Code"
                  formControlProps={{
                    fullWidth: true
                  }}
                  disabled
                  inputProps={{
                    value: body.promoCode ?? "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={6}>
                <CustomInput
                  labelText="Currency"
                  formControlProps={{
                    fullWidth: true
                  }}
                  disabled
                  inputProps={{
                    value:
                      body.agent && body.agent.billingCurrency
                        ? body.agent.billingCurrency.code
                        : "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={6}>
                <CustomInput
                  labelText="Discount Amount"
                  formControlProps={{
                    fullWidth: true
                  }}
                  disabled
                  inputProps={{
                    type: "number",
                    value: body.discountAmount ?? "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={6}>
                <CustomInput
                  labelText="Minimal Pax"
                  disabled
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    type: "number",
                    value: body.minimalPax ?? "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={6}>
                <CustomInput
                  labelText="Limit"
                  disabled
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    type: "number",
                    value: body.limit ?? "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={6}>
                <InputLabel className={classes.selectLabel}>
                  Effective From
                </InputLabel>
                <FormControl fullWidth>
                  <Datetime
                    value={new Date(body.effectiveFrom + "Z")}
                    onChange={e =>
                      setBody({
                        ...body,
                        effectiveFrom: e === "" ? null : e
                      })
                    }
                    dateFormat={tripDateFormat}
                    timeFormat={true}
                    disabled
                    closeOnSelect={true}
                    inputProps={{
                      placeholder: "Effective From",
                      disabled: true
                    }}
                  />
                </FormControl>
              </GridItem>
              <GridItem xs={12} md={6}>
                <InputLabel className={classes.selectLabel}>
                  Effective Until
                </InputLabel>
                <FormControl fullWidth>
                  <Datetime
                    value={new Date(body.effectiveUntil + "Z")}
                    onChange={e =>
                      setBody({
                        ...body,
                        effectiveUntil: e === "" ? null : e
                      })
                    }
                    dateFormat={tripDateFormat}
                    timeFormat={true}
                    disabled
                    closeOnSelect={true}
                    inputProps={{
                      placeholder: "Effective Until",
                      disabled: true
                    }}
                  />
                </FormControl>
              </GridItem>
              <GridItem xs={12} md={12}>
                <FormControlLabel
                  disabled
                  control={
                    <Checkbox
                      checked={body.onlyForRoundTrip}
                      checkedIcon={<Check className={classes.checkedIcon} />}
                      icon={<Check className={classes.uncheckedIcon} />}
                      classes={{
                        checked: classes.checked,
                        root: classes.checkRoot
                      }}
                      disabled
                    />
                  }
                  classes={{
                    label: classes.label,
                    root: classes.labelRoot
                  }}
                  label="Only For Round Trip"
                />
              </GridItem>
              <GridItem xs={12} md={12}>
                <FormControlLabel
                  disabled
                  control={
                    <Checkbox
                      checked={body.hasSectorRestriction}
                      checkedIcon={<Check className={classes.checkedIcon} />}
                      icon={<Check className={classes.uncheckedIcon} />}
                      classes={{
                        checked: classes.checked,
                        root: classes.checkRoot
                      }}
                      disabled
                    />
                  }
                  classes={{
                    label: classes.label,
                    root: classes.labelRoot
                  }}
                  label="Has Sector Restriction"
                />
              </GridItem>
              {body.hasSectorRestriction && (
                <GridItem xs={12} md={12}>
                  <CustomInput
                    labelText="ALLOWED ROUTES"
                    disabled
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      value: body.allowedSector ? body.allowedSector.name : "",
                      disabled: true
                    }}
                  />
                </GridItem>
              )}
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

DeleteAgentBookingPromoCodes.propTypes = {
  history: PropTypes.object
};
